export default __webpack_public_path__ + "static/media/upload-outline.407fb7dc.svg";